import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';
import { BannerComponent, ButtonComponent } from '@mode/capra';
import { CalendlyPopupButtonComponent } from '../calendly-popup-button/calendly-popup-button.component';

@Component({
  standalone: true,
  selector: 'mode-upgrade-banner',
  imports: [BannerComponent, ButtonComponent, CalendlyPopupButtonComponent, CommonModule],
  templateUrl: './upgrade-banner.component.html',
  styleUrls: ['./upgrade-banner.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class UpgradeBannerComponent implements OnInit {
  warningText?: string;
  tipMessage?: string;

  @Input()
  pythonPerformanceFirstTier = false;

  ngOnInit() {
    if (this.pythonPerformanceFirstTier) {
      this.warningText = 'Upgrade to access external libraries & enhanced notebooks';
      this.tipMessage = 'Manually install any external library you need in a more powerful notebook environment';
    }
  }
}
